import React from 'react';

const Friends = () => {
  return <div>Friends</div>;
};

export default Friends;
